import React, { ElementType, ReactElement } from 'react';
import styled from 'styled-components';
import Image from 'next/image';

const PlaceholderElementWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px !important;
    width: 300px !important;
    @media only screen and (max-width: 400px) {
      width: 200px !important;
      height: 200px !important;
    }
    max-width: 100% !important;
    position: relative !important;
  }
`;

const PlaceholderElement = ({ cta }: { cta?: ReactElement }) => {
  return (
    <PlaceholderElementWrapper className="flex-col h-[40vh]">
      <Image alt="" src="/images/new/placeholder/no-data.svg" layout="fill" />
      {cta && cta}
    </PlaceholderElementWrapper>
  );
};

export default PlaceholderElement;
